import { Response as ResponseRequest, Server } from "miragejs";

import {
  EfetivacaoRequisicao,
  EfetivacaoResposta,
  SimulacaoRequisicao,
} from "#/types";
import {
  ENDPOINT_ASSOCIADO_DADOS_PESSOAIS,
  ENDPOINT_ASSOCIADO_VALIDA_CONTA,
} from "../associado";
import { DADOS_ASSOCIADO_MOCK } from "../associado/mock";
import { ENDPOINT_DADOS_PROPOSTA } from "../buscaDadosProposta";
import { MOCK_DADOS_PROPOSTA } from "../buscaDadosProposta/mock";
import { ENDPOINT_PDF } from "../buscaPdfPropostaEApolice";
import { MOCK_PDF } from "../buscaPdfPropostaEApolice/mock";
import { ENDPOINT_DETALHE_COTACAO } from "../detalheCotacao";
import { MOCK_DETALHES_OFERTA } from "../detalheCotacao/mock";
import { ENDPOINT_ENDERECO } from "../endereco";
import { mockEnderecos } from "../endereco/mock";
import { ENDPOINT_OFERTAS } from "../ofertas";
import { MOCK_OFERTAS } from "../ofertas/mock.new";
import { MOCK_LISTA_COTACOES } from "../ofertas/mockLista";
import { ENDPOINT_PROPOSTAS } from "../proposta";
import { ENDPOINT_SEGURADORAS } from "../seguradoras";
import { MOCK_SEGURADORAS } from "../seguradoras/mock";
import { ENDPOINT_BASE_VEICULOS } from "../veiculo";
import { mockVeiculos } from "../veiculo/mock";

export function routes(server: Server, token: string) {
  server.get(ENDPOINT_ASSOCIADO_DADOS_PESSOAIS, (_, request) => {
    if (request.requestHeaders.Authorization.includes("testeErroMessage"))
      return new ResponseRequest(400, {}, { message: "Teste de erro" });

    if (request.requestHeaders.Authorization.includes("teste"))
      return new ResponseRequest(401, {}, {});

    if (request.requestHeaders.Authorization.includes("SicrediX"))
      return new ResponseRequest(
        200,
        {},
        { ...DADOS_ASSOCIADO_MOCK, apenasDigital: true }
      );

    return new ResponseRequest(200, {}, DADOS_ASSOCIADO_MOCK);
  });

  server.get(ENDPOINT_ASSOCIADO_VALIDA_CONTA, (_, request) => {
    if (request.queryParams.cooperativa === "1234")
      return new ResponseRequest(400, {}, { message: "Erro teste" });

    if (request.queryParams.cooperativa === "0101")
      return new ResponseRequest(200, {}, false);

    return new ResponseRequest(200, {}, true);
  });

  server.get(ENDPOINT_BASE_VEICULOS, (_, request) => {
    if (request.queryParams.placa === "ERR0E00")
      return new ResponseRequest(400, {}, { message: "Erro teste" });

    const veiculos = mockVeiculos.filter((veiculo) => {
      return (
        veiculo.chassi === request.queryParams.chassi ||
        veiculo.placa === request.queryParams.placa
      );
    });

    if (veiculos.length === 0) return new ResponseRequest(404, {}, {});

    return new ResponseRequest(200, {}, veiculos);
  });

  server.get(
    "https://auth.dev.sicredi.io/auth/realms/person/.well-known/openid-configuration",
    () => new ResponseRequest(200)
  );

  server.get("/time", () => new Date());

  server.get(
    `${ENDPOINT_ENDERECO}:cep`,
    (_, request) => {
      const cep = request.params.cep;

      const endereco = mockEnderecos.find(
        (itemEndereco) => itemEndereco.cep === cep
      );

      if (cep === "18000000") return new ResponseRequest(400, {}, {});

      if (!!!endereco)
        return new ResponseRequest(404, {}, { message: "Cep não encontrado" });

      return new ResponseRequest(200, {}, endereco);
    },
    {
      timing: 1000,
    }
  );

  server.post(
    ENDPOINT_OFERTAS,
    (_, request) => {
      const data = JSON.parse(request.requestBody) as SimulacaoRequisicao;
      return new ResponseRequest(
        200,
        {},
        {
          ...MOCK_OFERTAS,
          ofertas: MOCK_OFERTAS.ofertas.find(
            (oferta) => oferta.segmento === data.segmento
          ),
        }
      );
    },
    { timing: 1000 }
  );

  server.post(ENDPOINT_PROPOSTAS, (_, request) => {
    const data = JSON.parse(request.requestBody) as EfetivacaoRequisicao;
    const retorno: EfetivacaoResposta = {
      numero: data.identificador.numero,
      numeroProposta: "3",
      versao: data.identificador.versao,
      vistoria: data.identificador.numero === "111",
    };

    return new ResponseRequest(200, {}, retorno);
  });

  server.get(ENDPOINT_OFERTAS, () => {
    return new ResponseRequest(200, {}, MOCK_LISTA_COTACOES);
  });

  server.get(ENDPOINT_OFERTAS, () => {
    return new ResponseRequest(200, {}, MOCK_LISTA_COTACOES);
  });

  server.get(`${ENDPOINT_DETALHE_COTACAO}/:numeroCotacao`, (_, request) => {
    return new ResponseRequest(200, {}, MOCK_DETALHES_OFERTA);
  });

  server.get(ENDPOINT_DADOS_PROPOSTA, () => {
    return new ResponseRequest(200, {}, MOCK_DADOS_PROPOSTA);
  });

  server.get(ENDPOINT_SEGURADORAS, () => {
    return new ResponseRequest(200, {}, MOCK_SEGURADORAS);
  });

  server.get(ENDPOINT_PDF, () => {
    return new ResponseRequest(200, {}, MOCK_PDF);
  });

  server.passthrough();
}
